import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import DineAround from '../components/dineAround/DineAround';
import { shouldFetch, getShouldFetchAvailableEntertainments } from '../utils';
import { getShouldDineAroundSkip } from '../dineAround/dineAroundHelper';

const mapStateToProps = ({
  availableEntertainments,
  bookingSearch,
  bookedEntertainments,
  bookedEvents,
  config,
}, { detailPage, isSummaryPage }) => ({
  dineAroundItems: availableEntertainments.dineAroundItems,
  title: 'Setup your experience',
  subTitle: 'Dine Around',
  resId: bookingSearch.resId,
  siteCode: bookingSearch.siteCode,
  shouldFetchAvailableEntertainments: getShouldFetchAvailableEntertainments(availableEntertainments, bookedEntertainments, bookingSearch, config),
  shouldSkip: getShouldDineAroundSkip(availableEntertainments, bookingSearch, config),
  shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
  bookedEvents: bookedEvents.events,
  detailPage,
  isSummaryPage,
});

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DineAround);
